var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcQuantity0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2414_17963",
    transform: "translate(0 0.00909091) scale(0.0181818)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2414_17963",
    width: 55,
    height: 54,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAA2CAYAAABjhwHjAAAACXBIWXMAAAsSAAALEgHS3X78AAABp0lEQVRoge2ay23CQBRFDxZ7sh9LIRVAB0kJllxA3EFcgksgFcTsYwk6IB3EHRBpvIcKyMKDAoSEieIPT3pnZVnP0j0azXgxd7Db7TglLKobIAEi4P7bwHVQAitgZmOzPjcwOJULiyoFMmDUbrZGeQYyG5vN4csjubCocuCx01jNUQIPh4LB/kG4GMAEWLktBTi5sKgiZIvtmVBvKeBr5fI+krTEU1hUU4AgLKoEWYeHDynUKxf1HKQNIoAhMPX8oAQ2F6fax+e/OwqLajwEbj2G5zY2yf8yNYPbRi8eo+Pg8gxcixiAjU0OvPnMeslJReWkonJSUTmpqJxUVE4qKicVlZOKyklF5aSiclJROamonFRUTioqJxWVk4rKScVLzl3VXgWuhuF1jz8wr3aN372411VtB0zxq5bcDYF3/OSutb13jq2NzToAFn0naYEF1HtuAWz7zdI4OUDgKnxZr1GaZWljswJ3WtrYzIB5n4kaoqRu+ALHv4IUWHadpkFKIDksk56rAWfUopKafHMg/bUGvMe1TVPq9tukk3h/54O6wJ39VOD+BMiiaTUCqsQpAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuantity0);
export default __webpack_public_path__ + "static/media/ic-quantity-0.56bfd6741e8ac97cd37dc49100e5a0e3.svg";
export { ForwardRef as ReactComponent };